var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g, _rect2, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginEsim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 336,
    viewBox: "0 0 531 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_928_2349",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 531,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 531,
    height: 336,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_928_2349)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_928_2349",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -95,
    y: -39,
    width: 1117,
    height: 414
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M551.875 17.3519L374.429 17.3518L337.003 -15.2807L240.62 -15.2807L217.697 -35.2766L24.7505 -35.2766L24.7505 -36.8403L218.283 -36.8403L241.206 -16.8493L337.589 -16.8493L375.015 15.7881L551.289 15.7882L588.72 -16.8493L685.098 -16.8492L708.026 -36.8402L901.553 -36.8402L901.553 -35.2765L708.612 -35.2765L685.684 -15.2807L589.306 -15.2807L551.875 17.3519Z",
    fill: "url(#paint0_radial_928_2349)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M901.553 372.152L708.026 372.151L685.098 352.16L588.72 352.16L551.289 319.523L375.015 319.523L337.589 352.16L241.206 352.16L218.283 372.151L24.7505 372.151L24.7505 370.588L217.697 370.588L240.62 350.592L337.003 350.592L374.429 317.959L551.875 317.959L589.306 350.592L685.684 350.592L708.612 370.588L901.553 370.588L901.553 372.152Z",
    fill: "url(#paint1_radial_928_2349)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M999.32 72.473L976.109 52.2377L854.697 52.2377L816.103 18.5789L740.424 18.5789L696.914 56.5183L536.322 56.5183L491.243 17.2106L492.269 16.033L536.908 54.9497L696.328 54.9497L739.838 17.0103L816.689 17.0103L855.288 50.6691L976.695 50.6691L1000.35 71.2904L999.32 72.473Z",
    fill: "url(#paint2_radial_928_2349)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434.035 319.279L389.401 280.357L229.982 280.357L186.467 318.301L109.62 318.301L71.0213 284.643L-50.3905 284.643L-74.0415 264.021L-73.0104 262.839L-49.8041 283.074L71.6077 283.074L110.207 316.738L185.88 316.738L229.39 278.793L389.988 278.793L435.066 318.101L434.035 319.279Z",
    fill: "url(#paint3_radial_928_2349)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M492.269 319.279L491.243 318.101L536.321 278.793L696.914 278.794L740.424 316.738L816.102 316.738L854.696 283.074L976.108 283.074L999.319 262.839L1000.35 264.021L976.694 284.643L855.288 284.643L816.688 318.302L739.837 318.302L696.327 280.357L536.908 280.357L492.269 319.279Z",
    fill: "url(#paint4_radial_928_2349)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-73.0104 72.4726L-74.0415 71.2901L-50.3905 50.6688L71.0213 50.6688L109.62 17.0101L186.467 17.0101L229.982 54.9495L389.401 54.9495L434.035 16.0328L435.066 17.2105L389.988 56.5181L229.39 56.5181L185.88 18.5787L110.207 18.5787L71.6077 52.2374L-49.8041 52.2374L-73.0104 72.4726Z",
    fill: "url(#paint5_radial_928_2349)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.651 346.448L66.5792 346.448L31.0195 315.443L-64.1416 315.443L-64.1416 313.879L31.6059 313.879L67.1655 344.884L205.065 344.884L280.636 278.989L281.667 280.167L205.651 346.448Z",
    fill: "url(#paint6_radial_928_2349)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.636 56.3269L205.065 -9.57347L67.1655 -9.57349L31.6059 21.4318L-64.1416 21.4318L-64.1416 19.8681L31.0195 19.8681L66.5792 -11.1372L205.651 -11.1372L281.667 55.1444L280.636 56.3269Z",
    fill: "url(#paint7_radial_928_2349)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.906 332.58L299.571 332.58L275.246 311.362L268.507 311.362L268.507 309.799L275.832 309.799L300.158 331.016L359.906 331.016L359.906 332.58Z",
    fill: "url(#paint8_radial_928_2349)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M268.649 307.639C268.069 307.639 267.502 307.811 267.02 308.133C266.538 308.455 266.162 308.913 265.94 309.449C265.719 309.985 265.66 310.574 265.774 311.143C265.887 311.712 266.166 312.234 266.576 312.644C266.986 313.054 267.508 313.333 268.077 313.446C268.646 313.56 269.235 313.502 269.771 313.28C270.307 313.058 270.765 312.682 271.087 312.2C271.409 311.718 271.581 311.151 271.581 310.571C271.581 309.793 271.272 309.047 270.722 308.498C270.173 307.948 269.427 307.639 268.649 307.639Z",
    fill: "url(#paint9_radial_928_2349)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M275.833 25.5127L268.508 25.5127L268.508 23.9489L275.246 23.9489L299.572 2.73145L359.906 2.73146L359.906 4.30003L300.158 4.30002L275.833 25.5127Z",
    fill: "url(#paint10_radial_928_2349)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.649 21.7886C268.069 21.7886 267.502 21.9605 267.02 22.2827C266.538 22.6049 266.162 23.0627 265.94 23.5985C265.719 24.1342 265.66 24.7238 265.774 25.2925C265.887 25.8612 266.166 26.3837 266.576 26.7937C266.986 27.2037 267.508 27.483 268.077 27.5961C268.646 27.7093 269.235 27.6512 269.771 27.4293C270.307 27.2074 270.765 26.8316 271.087 26.3494C271.409 25.8672 271.581 25.3004 271.581 24.7205C271.581 23.9429 271.272 23.1972 270.722 22.6473C270.173 22.0975 269.427 21.7886 268.649 21.7886Z",
    fill: "url(#paint11_radial_928_2349)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M597.418 42.3764L520.391 42.3764L520.391 40.8078L596.827 40.8078L612.747 26.9299L613.774 28.1125L597.418 42.3764Z",
    fill: "url(#paint12_radial_928_2349)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M313.562 308.382L312.531 307.199L328.891 292.935L405.913 292.935L405.913 294.504L329.477 294.504L313.562 308.382Z",
    fill: "url(#paint13_radial_928_2349)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M311.221 305.474C310.787 305.856 310.475 306.359 310.325 306.918C310.176 307.477 310.195 308.068 310.381 308.616C310.566 309.165 310.91 309.646 311.369 309.999C311.827 310.352 312.38 310.562 312.958 310.601C313.535 310.64 314.112 310.508 314.614 310.22C315.116 309.933 315.522 309.503 315.781 308.985C316.039 308.467 316.139 307.884 316.067 307.31C315.994 306.735 315.754 306.195 315.375 305.758C315.122 305.465 314.813 305.225 314.467 305.052C314.12 304.88 313.743 304.777 313.357 304.751C312.971 304.724 312.583 304.775 312.217 304.899C311.85 305.023 311.512 305.219 311.221 305.474Z",
    fill: "url(#paint14_radial_928_2349)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M612.747 308.382L596.827 294.504L520.391 294.504L520.391 292.936L597.418 292.936L613.774 307.2L612.747 308.382Z",
    fill: "url(#paint15_radial_928_2349)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M405.913 42.3762L328.891 42.3762L312.531 28.1123L313.562 26.9297L329.477 40.8076L405.913 40.8076L405.913 42.3762Z",
    fill: "url(#paint16_radial_928_2349)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.072 25.4001C314.634 25.0214 314.094 24.7808 313.52 24.7085C312.945 24.6362 312.362 24.7356 311.844 24.9941C311.327 25.2525 310.897 25.6585 310.609 26.1609C310.322 26.6633 310.189 27.2396 310.228 27.8171C310.268 28.3946 310.477 28.9475 310.831 29.4062C311.184 29.8649 311.665 30.2087 312.213 30.3945C312.761 30.5802 313.352 30.5994 313.911 30.4498C314.471 30.3002 314.973 29.9884 315.355 29.5537C315.611 29.2631 315.806 28.9247 315.931 28.5582C316.055 28.1916 316.105 27.804 316.079 27.4179C316.052 27.0318 315.95 26.6547 315.777 26.3083C315.604 25.962 315.365 25.6534 315.072 25.4001Z",
    fill: "url(#paint17_radial_928_2349)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8201 178.569L-46.3638 178.569L-46.3638 177.006L75.2337 177.006L85.9549 167.653L75.2337 158.305L-46.3638 158.305L-46.3638 156.741L75.8201 156.741L88.3347 167.653L75.8201 178.569Z",
    fill: "url(#paint18_radial_928_2349)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M785.81 163.407L664.51 163.407L649.855 150.623L276.453 150.623L261.793 163.407L140.498 163.407L100.732 128.731L-92.2148 128.731L-92.2148 127.163L101.318 127.163L141.085 161.843L261.207 161.843L275.866 149.06L650.442 149.06L665.102 161.843L785.218 161.843L824.99 127.163L1018.52 127.163L1018.52 128.732L825.577 128.732L785.81 163.407Z",
    fill: "url(#paint19_radial_928_2349)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1018.52 208.148L824.99 208.148L785.218 173.468L665.102 173.468L650.442 186.252L275.866 186.252L261.207 173.468L141.085 173.468L101.318 208.148L-92.2149 208.148L-92.2148 206.58L100.732 206.58L140.498 171.905L261.793 171.905L276.453 184.688L649.855 184.688L664.51 171.905L785.81 171.905L825.577 206.58L1018.52 206.58L1018.52 208.148Z",
    fill: "url(#paint20_radial_928_2349)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.725 188.494L18.8232 188.494L18.8232 190.058L121.725 190.058L121.725 188.494Z",
    fill: "url(#paint21_radial_928_2349)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9695 186.334C18.3897 186.334 17.8228 186.506 17.3406 186.829C16.8585 187.151 16.4827 187.609 16.2608 188.144C16.0389 188.68 15.9808 189.27 16.0939 189.838C16.2071 190.407 16.4863 190.93 16.8964 191.34C17.3064 191.75 17.8288 192.029 18.3976 192.142C18.9663 192.255 19.5558 192.197 20.0916 191.975C20.6273 191.753 21.0852 191.377 21.4074 190.895C21.7295 190.413 21.9015 189.846 21.9015 189.266C21.9015 188.489 21.5926 187.743 21.0427 187.193C20.4929 186.643 19.7471 186.334 18.9695 186.334Z",
    fill: "url(#paint22_radial_928_2349)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121.725 145.248L18.8232 145.248L18.8232 146.812L121.725 146.812L121.725 145.248Z",
    fill: "url(#paint23_radial_928_2349)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9695 148.977C20.5942 148.977 21.9113 147.66 21.9113 146.035C21.9113 144.41 20.5942 143.093 18.9695 143.093C17.3449 143.093 16.0278 144.41 16.0278 146.035C16.0278 147.66 17.3449 148.977 18.9695 148.977Z",
    fill: "url(#paint24_radial_928_2349)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M760.546 123.83L665.918 123.83L631.761 94.0515L294.543 94.0514L260.391 123.83L165.762 123.83L129.973 92.6245L-31.0885 92.6245L-44.5461 104.362L-45.5772 103.184L-31.6748 91.0559L130.559 91.0559L166.349 122.266L259.804 122.267L293.957 92.4877L632.352 92.4878L666.504 122.267L759.955 122.267L795.749 91.0561L957.979 91.0561L971.886 103.185L970.855 104.362L957.392 92.6247L796.336 92.6246L760.546 123.83Z",
    fill: "url(#paint25_radial_928_2349)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M957.979 244.255L795.749 244.255L759.955 213.045L666.504 213.045L632.352 242.823L293.957 242.823L259.804 213.044L166.349 213.044L130.559 244.255L-31.6748 244.255L-45.5772 232.126L-44.5461 230.949L-31.0885 242.686L129.973 242.686L165.762 211.481L260.391 211.481L294.543 241.26L631.761 241.26L665.918 211.481L760.546 211.481L796.336 242.687L957.392 242.687L970.855 230.949L971.886 232.127L957.979 244.255Z",
    fill: "url(#paint26_radial_928_2349)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M514.957 130.598L504.476 130.598L504.476 129.035L514.371 129.035L534.45 111.526L653.892 111.526L653.892 113.095L535.036 113.095L514.957 130.598Z",
    fill: "url(#paint27_radial_928_2349)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M504.622 126.875C504.043 126.875 503.476 127.047 502.993 127.369C502.511 127.691 502.136 128.149 501.914 128.685C501.692 129.221 501.634 129.81 501.747 130.379C501.86 130.948 502.139 131.47 502.549 131.88C502.959 132.29 503.482 132.569 504.05 132.683C504.619 132.796 505.209 132.738 505.744 132.516C506.28 132.294 506.738 131.918 507.06 131.436C507.382 130.954 507.554 130.387 507.554 129.807C507.554 129.029 507.245 128.284 506.696 127.734C506.146 127.184 505.4 126.875 504.622 126.875Z",
    fill: "url(#paint28_radial_928_2349)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M391.86 223.785L272.417 223.785L272.417 222.217L391.273 222.217L411.352 204.713L421.834 204.713L421.834 206.277L411.938 206.277L391.86 223.785Z",
    fill: "url(#paint29_radial_928_2349)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M421.687 208.437C423.312 208.437 424.629 207.12 424.629 205.495C424.629 203.87 423.312 202.553 421.687 202.553C420.063 202.553 418.746 203.87 418.746 205.495C418.746 207.12 420.063 208.437 421.687 208.437Z",
    fill: "url(#paint30_radial_928_2349)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M653.892 223.785L534.45 223.785L514.371 206.277L504.476 206.277L504.476 204.713L514.957 204.713L535.036 222.217L653.892 222.217L653.892 223.785Z",
    fill: "url(#paint31_radial_928_2349)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M504.622 202.553C504.043 202.553 503.476 202.725 502.993 203.047C502.511 203.37 502.136 203.827 501.914 204.363C501.692 204.899 501.634 205.488 501.747 206.057C501.86 206.626 502.139 207.148 502.549 207.558C502.959 207.968 503.482 208.248 504.05 208.361C504.619 208.474 505.209 208.416 505.744 208.194C506.28 207.972 506.738 207.596 507.06 207.114C507.382 206.632 507.554 206.065 507.554 205.485C507.554 204.708 507.245 203.962 506.696 203.412C506.146 202.862 505.4 202.553 504.622 202.553Z",
    fill: "url(#paint32_radial_928_2349)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M421.834 130.598L411.352 130.598L391.273 113.095L272.417 113.094L272.417 111.526L391.86 111.526L411.938 129.035L421.834 129.035L421.834 130.598Z",
    fill: "url(#paint33_radial_928_2349)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M421.687 132.758C423.312 132.758 424.629 131.441 424.629 129.817C424.629 128.192 423.312 126.875 421.687 126.875C420.063 126.875 418.746 128.192 418.746 129.817C418.746 131.441 420.063 132.758 421.687 132.758Z",
    fill: "url(#paint34_radial_928_2349)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.779 224.068L-2.80518 222.886L3.88454 217.051L108.995 217.051L142.991 187.405L205.338 187.405L233.319 211.808L232.293 212.986L204.752 188.973L143.577 188.973L109.586 218.62L4.47093 218.62L-1.779 224.068Z",
    fill: "url(#paint35_radial_928_2349)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.11465 221.161C-4.54933 221.543 -4.86112 222.045 -5.01073 222.605C-5.16034 223.164 -5.14108 223.755 -4.95536 224.303C-4.76964 224.851 -4.42579 225.332 -3.96713 225.685C-3.50847 226.039 -2.95553 226.248 -2.37801 226.288C-1.80049 226.327 -1.22422 226.194 -0.721841 225.907C-0.21946 225.619 0.186557 225.189 0.445029 224.672C0.703501 224.154 0.802856 223.571 0.730591 222.996C0.658326 222.422 0.41767 221.882 0.0389431 221.444C-0.214278 221.151 -0.522939 220.912 -0.869251 220.739C-1.21556 220.566 -1.59267 220.464 -1.97881 220.437C-2.36495 220.411 -2.75248 220.461 -3.11906 220.585C-3.48564 220.71 -3.82401 220.905 -4.11465 221.161Z",
    fill: "url(#paint36_radial_928_2349)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M205.338 147.906L142.991 147.906L108.995 118.26L3.88454 118.26L-2.80518 112.425L-1.77899 111.242L4.47094 116.691L109.586 116.691L143.577 146.338L204.752 146.338L232.293 122.325L233.319 123.503L205.338 147.906Z",
    fill: "url(#paint37_radial_928_2349)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.244536 109.713C-0.682318 109.334 -1.22242 109.094 -1.79676 109.021C-2.3711 108.949 -2.95397 109.049 -3.47193 109.307C-3.98989 109.565 -4.41975 109.972 -4.70732 110.474C-4.9949 110.976 -5.12733 111.553 -5.08792 112.13C-5.04852 112.708 -4.83903 113.261 -4.48587 113.719C-4.13272 114.178 -3.65171 114.522 -3.10344 114.707C-2.55517 114.893 -1.96419 114.912 -1.40499 114.763C-0.845795 114.613 -0.343401 114.301 0.0388781 113.867C0.294475 113.576 0.490005 113.238 0.614178 112.871C0.738352 112.505 0.788714 112.117 0.762365 111.731C0.736017 111.345 0.633471 110.968 0.460653 110.621C0.287835 110.275 0.0481709 109.966 -0.244536 109.713Z",
    fill: "url(#paint38_radial_928_2349)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M148.571 292.872L116.794 292.872L101.372 279.419L102.398 278.241L117.38 291.303L147.985 291.303L200.384 245.614L277.704 245.614L315.976 278.989L314.945 280.167L277.118 247.177L200.97 247.177L148.571 292.872Z",
    fill: "url(#paint39_radial_928_2349)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M103.932 276.707C103.494 276.328 102.954 276.088 102.38 276.015C101.806 275.943 101.223 276.043 100.705 276.301C100.187 276.559 99.757 276.965 99.4694 277.468C99.1819 277.97 99.0494 278.546 99.0888 279.124C99.1282 279.702 99.3377 280.254 99.6909 280.713C100.044 281.172 100.525 281.516 101.073 281.701C101.622 281.887 102.213 281.906 102.772 281.757C103.331 281.607 103.833 281.295 104.216 280.861C104.471 280.57 104.667 280.232 104.791 279.865C104.915 279.498 104.965 279.111 104.939 278.725C104.913 278.339 104.81 277.962 104.637 277.615C104.465 277.269 104.225 276.96 103.932 276.707Z",
    fill: "url(#paint40_radial_928_2349)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M277.704 89.6975L200.384 89.6975L147.985 44.008L117.38 44.008L102.398 57.0698L101.372 55.8922L116.794 42.4395L148.572 42.4395L200.97 88.1338L277.118 88.1338L314.945 55.1446L315.976 56.3271L277.704 89.6975Z",
    fill: "url(#paint41_radial_928_2349)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M100.062 54.1673C99.6274 54.5496 99.3156 55.052 99.166 55.6112C99.0164 56.1704 99.0357 56.7614 99.2214 57.3096C99.4071 57.8579 99.751 58.3389 100.21 58.692C100.668 59.0452 101.221 59.2547 101.799 59.2941C102.376 59.3335 102.953 59.2011 103.455 58.9135C103.957 58.6259 104.363 58.1961 104.622 57.6781C104.88 57.1602 104.98 56.5773 104.907 56.0029C104.835 55.4286 104.594 54.8885 104.216 54.4507C103.962 54.158 103.654 53.9183 103.307 53.7455C102.961 53.5727 102.584 53.4702 102.198 53.4438C101.812 53.4175 101.424 53.4678 101.058 53.592C100.691 53.7162 100.353 53.9117 100.062 54.1673Z",
    fill: "url(#paint42_radial_928_2349)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M133.599 264.041L14.4595 264.041L14.4595 262.472L133.013 262.472L167.321 232.557L227.172 232.557L242.443 245.873L241.416 247.05L226.586 234.12L167.913 234.12L133.599 264.041Z",
    fill: "url(#paint43_radial_928_2349)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6058 260.312C14.0259 260.312 13.459 260.484 12.9769 260.806C12.4947 261.129 12.1189 261.586 11.897 262.122C11.6751 262.658 11.617 263.247 11.7302 263.816C11.8433 264.385 12.1225 264.907 12.5326 265.317C12.9426 265.727 13.465 266.007 14.0338 266.12C14.6025 266.233 15.192 266.175 15.7278 265.953C16.2635 265.731 16.7214 265.355 17.0436 264.873C17.3658 264.391 17.5377 263.824 17.5377 263.244C17.5377 262.467 17.2288 261.721 16.679 261.171C16.1291 260.621 15.3834 260.312 14.6058 260.312Z",
    fill: "url(#paint44_radial_928_2349)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.172 102.755L167.321 102.755L133.013 72.8391L14.4595 72.8391L14.4595 71.2705L133.599 71.2705L167.913 101.191L226.586 101.191L241.416 88.2563L242.443 89.4388L227.172 102.755Z",
    fill: "url(#paint45_radial_928_2349)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6058 69.1106C14.0259 69.1106 13.459 69.2825 12.9769 69.6047C12.4947 69.9269 12.1189 70.3848 11.897 70.9205C11.6751 71.4563 11.617 72.0458 11.7302 72.6145C11.8433 73.1833 12.1225 73.7057 12.5326 74.1158C12.9426 74.5258 13.465 74.805 14.0338 74.9181C14.6025 75.0313 15.192 74.9732 15.7278 74.7513C16.2635 74.5294 16.7214 74.1536 17.0436 73.6714C17.3658 73.1893 17.5377 72.6224 17.5377 72.0425C17.5377 71.2649 17.2288 70.5192 16.679 69.9694C16.1291 69.4195 15.3834 69.1106 14.6058 69.1106Z",
    fill: "url(#paint46_radial_928_2349)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M466.101 48.0884L460.203 48.0884L444.918 34.7578L417.446 34.7578L417.446 33.1941L445.509 33.1941L460.79 46.5198L465.515 46.5198L480.8 33.1941L511.659 33.1941L511.659 34.7578L481.387 34.7578L466.101 48.0884Z",
    fill: "url(#paint47_radial_928_2349)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M417.593 31.0342C417.013 31.0342 416.446 31.2061 415.964 31.5283C415.482 31.8505 415.106 32.3084 414.884 32.8441C414.662 33.3799 414.604 33.9694 414.717 34.5381C414.83 35.1069 415.109 35.6293 415.519 36.0393C415.929 36.4493 416.452 36.7286 417.021 36.8417C417.589 36.9549 418.179 36.8968 418.715 36.6749C419.25 36.453 419.708 36.0772 420.03 35.595C420.353 35.1129 420.525 34.546 420.525 33.9661C420.525 33.1885 420.216 32.4428 419.666 31.8929C419.116 31.3431 418.37 31.0342 417.593 31.0342Z",
    fill: "url(#paint48_radial_928_2349)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M508.864 302.117L480.8 302.117L465.515 288.791L460.789 288.791L445.509 302.117L414.65 302.117L414.65 300.553L444.918 300.553L460.203 287.223L466.101 287.223L481.386 300.553L508.864 300.553L508.864 302.117Z",
    fill: "url(#paint49_radial_928_2349)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M508.717 304.277C509.297 304.277 509.864 304.105 510.346 303.783C510.828 303.461 511.204 303.003 511.426 302.467C511.648 301.932 511.706 301.342 511.593 300.773C511.48 300.205 511.2 299.682 510.79 299.272C510.38 298.862 509.858 298.583 509.289 298.47C508.72 298.357 508.131 298.415 507.595 298.637C507.059 298.858 506.601 299.234 506.279 299.716C505.957 300.199 505.785 300.765 505.785 301.345C505.785 302.123 506.094 302.869 506.644 303.418C507.194 303.968 507.939 304.277 508.717 304.277Z",
    fill: "url(#paint50_radial_928_2349)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M487.031 108.194L436.484 108.194L436.484 109.757L487.031 109.757L487.031 108.194Z",
    fill: "url(#paint51_radial_928_2349)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M486.884 111.936C487.464 111.936 488.031 111.764 488.513 111.442C488.995 111.12 489.371 110.662 489.593 110.126C489.815 109.591 489.873 109.001 489.76 108.432C489.647 107.864 489.367 107.341 488.957 106.931C488.547 106.521 488.025 106.242 487.456 106.129C486.887 106.016 486.298 106.074 485.762 106.296C485.226 106.518 484.768 106.893 484.446 107.376C484.124 107.858 483.952 108.425 483.952 109.004C483.952 109.782 484.261 110.528 484.811 111.078C485.361 111.627 486.106 111.936 486.884 111.936Z",
    fill: "url(#paint52_radial_928_2349)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M489.826 225.554L439.279 225.554L439.279 227.118L489.826 227.118L489.826 225.554Z",
    fill: "url(#paint53_radial_928_2349)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M439.426 223.389C438.846 223.389 438.279 223.561 437.797 223.883C437.315 224.205 436.939 224.663 436.717 225.199C436.495 225.735 436.437 226.324 436.55 226.893C436.663 227.462 436.942 227.984 437.352 228.394C437.762 228.804 438.285 229.084 438.854 229.197C439.422 229.31 440.012 229.252 440.548 229.03C441.083 228.808 441.541 228.432 441.863 227.95C442.186 227.468 442.358 226.901 442.358 226.321C442.358 225.544 442.049 224.798 441.499 224.248C440.949 223.698 440.203 223.389 439.426 223.389Z",
    fill: "url(#paint54_radial_928_2349)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M611.14 141.241L315.17 141.241L302.924 130.564L281.462 130.564L281.462 128.995L303.515 128.995L315.756 139.672L610.553 139.672L622.794 128.995L642.047 128.995L642.047 130.564L623.38 130.564L611.14 141.241Z",
    fill: "url(#paint55_radial_928_2349)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M644.847 206.316L622.794 206.316L610.553 195.639L315.756 195.639L303.515 206.316L284.257 206.316L284.257 204.747L302.924 204.747L315.17 194.07L611.14 194.07L623.381 204.747L644.847 204.747L644.847 206.316Z",
    fill: "url(#paint56_radial_928_2349)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M284.409 202.587C283.829 202.587 283.262 202.759 282.78 203.081C282.298 203.403 281.922 203.861 281.7 204.397C281.478 204.933 281.42 205.522 281.533 206.091C281.647 206.66 281.926 207.182 282.336 207.592C282.746 208.002 283.268 208.282 283.837 208.395C284.406 208.508 284.995 208.45 285.531 208.228C286.067 208.006 286.525 207.63 286.847 207.148C287.169 206.666 287.341 206.099 287.341 205.519C287.341 204.742 287.032 203.996 286.482 203.446C285.932 202.896 285.187 202.587 284.409 202.587Z",
    fill: "url(#paint57_radial_928_2349)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M463.155 85.7445L448.822 73.2446L384.686 73.2446L375.406 81.3368L327 81.3368L327 79.7731L374.82 79.7731L384.1 71.676L449.409 71.676L463.155 83.6628L476.901 71.6761L542.21 71.6761L551.489 79.7731L596.509 79.7731L596.509 81.3368L550.903 81.3368L541.623 73.2447L477.487 73.2447L463.155 85.7445Z",
    fill: "url(#paint58_radial_928_2349)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M542.21 263.636L476.901 263.636L463.155 251.649L449.409 263.636L384.1 263.636L374.82 255.539L329.8 255.539L329.8 253.975L375.407 253.975L384.686 262.067L448.823 262.067L463.155 249.567L477.487 262.067L541.624 262.067L550.903 253.975L599.305 253.975L599.305 255.539L551.49 255.539L542.21 263.636Z",
    fill: "url(#paint59_radial_928_2349)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M329.947 257.698C331.571 257.698 332.888 256.381 332.888 254.756C332.888 253.132 331.571 251.814 329.947 251.814C328.322 251.814 327.005 253.132 327.005 254.756C327.005 256.381 328.322 257.698 329.947 257.698Z",
    fill: "url(#paint60_radial_928_2349)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M279.746 230.181L242.491 230.181L235.723 224.278L236.754 223.096L243.077 228.613L279.746 228.613L279.746 230.181Z",
    fill: "url(#paint61_radial_928_2349)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M238.284 221.566C237.846 221.187 237.306 220.946 236.731 220.873C236.157 220.8 235.574 220.899 235.055 221.157C234.537 221.416 234.107 221.822 233.819 222.324C233.531 222.827 233.398 223.404 233.438 223.981C233.477 224.559 233.687 225.112 234.041 225.571C234.394 226.03 234.876 226.374 235.424 226.559C235.973 226.745 236.564 226.763 237.124 226.613C237.683 226.463 238.185 226.15 238.567 225.715C238.822 225.425 239.017 225.086 239.141 224.72C239.264 224.354 239.315 223.967 239.288 223.582C239.262 223.196 239.16 222.82 238.987 222.474C238.815 222.128 238.576 221.819 238.284 221.566Z",
    fill: "url(#paint62_radial_928_2349)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M236.754 112.215L235.723 111.032L242.491 105.129L279.746 105.129L279.746 106.698L243.077 106.698L236.754 112.215Z",
    fill: "url(#paint63_radial_928_2349)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M234.414 109.312C233.979 109.695 233.668 110.197 233.518 110.756C233.368 111.315 233.388 111.906 233.573 112.455C233.759 113.003 234.103 113.484 234.562 113.837C235.02 114.19 235.573 114.4 236.151 114.439C236.728 114.479 237.305 114.346 237.807 114.058C238.309 113.771 238.715 113.341 238.974 112.823C239.232 112.305 239.332 111.722 239.259 111.148C239.187 110.574 238.946 110.034 238.568 109.596C238.315 109.303 238.006 109.063 237.66 108.891C237.313 108.718 236.936 108.615 236.55 108.589C236.164 108.562 235.776 108.613 235.41 108.737C235.043 108.861 234.705 109.057 234.414 109.312Z",
    fill: "url(#paint64_radial_928_2349)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M166.348 306.471L119.726 306.471L119.726 304.902L165.762 304.902L219.099 258.397L291.914 258.397L291.914 259.96L219.685 259.96L166.348 306.471Z",
    fill: "url(#paint65_radial_928_2349)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M119.873 302.742C119.293 302.742 118.726 302.914 118.244 303.236C117.762 303.558 117.386 304.016 117.164 304.552C116.942 305.088 116.884 305.677 116.997 306.246C117.11 306.815 117.39 307.337 117.8 307.747C118.21 308.157 118.732 308.437 119.301 308.55C119.87 308.663 120.459 308.605 120.995 308.383C121.531 308.161 121.989 307.785 122.311 307.303C122.633 306.821 122.805 306.254 122.805 305.674C122.805 304.897 122.496 304.151 121.946 303.601C121.396 303.051 120.65 302.742 119.873 302.742Z",
    fill: "url(#paint66_radial_928_2349)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M291.914 76.9142L219.099 76.9142L165.763 30.4087L119.726 30.4087L119.726 28.8401L166.349 28.8401L219.686 75.3505L291.914 75.3505L291.914 76.9142Z",
    fill: "url(#paint67_radial_928_2349)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M119.873 26.6807C119.293 26.6807 118.726 26.8526 118.244 27.1748C117.762 27.4969 117.386 27.9548 117.164 28.4906C116.942 29.0263 116.884 29.6159 116.997 30.1846C117.11 30.7533 117.39 31.2758 117.8 31.6858C118.21 32.0958 118.732 32.3751 119.301 32.4882C119.87 32.6013 120.459 32.5433 120.995 32.3214C121.531 32.0995 121.989 31.7236 122.311 31.2415C122.633 30.7593 122.805 30.1925 122.805 29.6126C122.805 28.835 122.496 28.0892 121.946 27.5394C121.396 26.9895 120.65 26.6807 119.873 26.6807Z",
    fill: "url(#paint68_radial_928_2349)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0187 298.921L43.7788 298.921L43.7788 300.485L89.0187 300.485L89.0187 298.921Z",
    fill: "url(#paint69_radial_928_2349)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9256 296.756C43.3457 296.756 42.7789 296.928 42.2967 297.25C41.8145 297.573 41.4387 298.031 41.2168 298.566C40.9949 299.102 40.9369 299.692 41.05 300.26C41.1631 300.829 41.4424 301.351 41.8524 301.762C42.2624 302.172 42.7849 302.451 43.3536 302.564C43.9223 302.677 44.5119 302.619 45.0476 302.397C45.5833 302.175 46.0413 301.799 46.3634 301.317C46.6856 300.835 46.8575 300.268 46.8575 299.688C46.8575 298.911 46.5486 298.165 45.9988 297.615C45.4489 297.065 44.7032 296.756 43.9256 296.756Z",
    fill: "url(#paint70_radial_928_2349)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0187 34.8262L43.7788 34.8262L43.7788 36.3899L89.0187 36.3899L89.0187 34.8262Z",
    fill: "url(#paint71_radial_928_2349)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9256 32.6665C43.3457 32.6665 42.7789 32.8385 42.2967 33.1606C41.8145 33.4828 41.4387 33.9407 41.2168 34.4764C40.9949 35.0122 40.9369 35.6017 41.05 36.1704C41.1631 36.7392 41.4424 37.2616 41.8524 37.6716C42.2624 38.0817 42.7849 38.3609 43.3536 38.4741C43.9223 38.5872 44.5119 38.5291 45.0476 38.3072C45.5833 38.0853 46.0413 37.7095 46.3634 37.2273C46.6856 36.7452 46.8575 36.1783 46.8575 35.5984C46.8575 34.8208 46.5486 34.0751 45.9988 33.5252C45.4489 32.9754 44.7032 32.6665 43.9256 32.6665Z",
    fill: "url(#paint72_radial_928_2349)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M199.333 331.153L82.016 331.153L71.3877 321.883L72.4188 320.7L82.6024 329.584L198.746 329.584L226.585 305.308L249.806 305.308L249.806 306.876L227.172 306.876L199.333 331.153Z",
    fill: "url(#paint73_radial_928_2349)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9483 319.171C73.5105 318.792 72.9704 318.552 72.3961 318.479C71.8218 318.407 71.2389 318.507 70.7209 318.765C70.203 319.024 69.7731 319.43 69.4855 319.932C69.198 320.434 69.0655 321.011 69.1049 321.588C69.1444 322.166 69.3538 322.719 69.707 323.177C70.0601 323.636 70.5412 323.98 71.0894 324.165C71.6377 324.351 72.2287 324.37 72.7879 324.221C73.3471 324.071 73.8495 323.759 74.2317 323.325C74.4873 323.034 74.6829 322.696 74.807 322.329C74.9312 321.963 74.9816 321.575 74.9552 321.189C74.9289 320.803 74.8263 320.426 74.6535 320.079C74.4807 319.733 74.241 319.424 73.9483 319.171Z",
    fill: "url(#paint74_radial_928_2349)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M249.806 30.0033L226.585 30.0033L198.746 5.72683L82.6024 5.72681L72.4188 14.6106L71.3877 13.428L82.016 4.1582L199.333 4.15823L227.172 28.4347L249.806 28.4347L249.806 30.0033Z",
    fill: "url(#paint75_radial_928_2349)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0782 11.7029C69.6436 12.0852 69.3318 12.5876 69.1821 13.1468C69.0325 13.706 69.0518 14.297 69.2375 14.8452C69.4232 15.3935 69.7671 15.8745 70.2257 16.2277C70.6844 16.5809 71.2373 16.7903 71.8149 16.8297C72.3924 16.8691 72.9687 16.7367 73.471 16.4491C73.9734 16.1615 74.3794 15.7317 74.6379 15.2138C74.8964 14.6958 74.9957 14.1129 74.9235 13.5386C74.8512 12.9642 74.6106 12.4241 74.2318 11.9864C73.9786 11.6937 73.6699 11.454 73.3236 11.2811C72.9773 11.1083 72.6002 11.0058 72.2141 10.9795C71.8279 10.9531 71.4404 11.0035 71.0738 11.1276C70.7072 11.2518 70.3689 11.4473 70.0782 11.7029Z",
    fill: "url(#paint76_radial_928_2349)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M289.056 352.375L271.733 337.271L242.775 337.271L242.775 335.702L272.324 335.702L290.087 351.198L289.056 352.375Z",
    fill: "url(#paint77_radial_928_2349)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M242.921 333.542C242.341 333.542 241.774 333.714 241.292 334.037C240.81 334.359 240.434 334.817 240.212 335.352C239.991 335.888 239.932 336.478 240.046 337.046C240.159 337.615 240.438 338.138 240.848 338.548C241.258 338.958 241.78 339.237 242.349 339.35C242.918 339.463 243.507 339.405 244.043 339.183C244.579 338.961 245.037 338.585 245.359 338.103C245.681 337.621 245.853 337.054 245.853 336.474C245.853 335.697 245.544 334.951 244.994 334.401C244.445 333.851 243.699 333.542 242.921 333.542Z",
    fill: "url(#paint78_radial_928_2349)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M242.921 -4.12012C242.341 -4.12012 241.774 -3.94817 241.292 -3.626C240.81 -3.30384 240.434 -2.84591 240.212 -2.31017C239.991 -1.77443 239.932 -1.18492 240.046 -0.616183C240.159 -0.0474415 240.438 0.474973 240.848 0.885013C241.258 1.29505 241.78 1.5743 242.349 1.68743C242.918 1.80056 243.507 1.7425 244.043 1.52059C244.579 1.29868 245.037 0.922892 245.359 0.440736C245.681 -0.0414195 245.853 -0.608288 245.853 -1.18817C245.853 -1.96577 245.544 -2.71151 244.994 -3.26136C244.445 -3.8112 243.699 -4.12012 242.921 -4.12012Z",
    fill: "url(#paint79_radial_928_2349)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0983 347.538L-52.2915 347.538L-52.2915 345.969L33.5119 345.969L50.4487 331.202L51.4749 332.384L34.0983 347.538Z",
    fill: "url(#paint80_radial_928_2349)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4492 4.10929L33.5124 -10.658L-52.291 -10.658L-52.291 -12.2266L34.0987 -12.2265L51.4754 2.92671L50.4492 4.10929Z",
    fill: "url(#paint81_radial_928_2349)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M111.727 231.506L35.98 231.506L35.98 229.937L111.14 229.937L146.114 199.445L179.684 199.445L193.855 211.798L192.824 212.976L179.098 201.009L146.7 201.009L111.727 231.506Z",
    fill: "url(#paint82_radial_928_2349)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1263 227.777C35.5464 227.777 34.9795 227.949 34.4974 228.271C34.0152 228.594 33.6394 229.052 33.4175 229.587C33.1956 230.123 33.1375 230.713 33.2507 231.281C33.3638 231.85 33.643 232.372 34.0531 232.782C34.4631 233.193 34.9855 233.472 35.5543 233.585C36.123 233.698 36.7125 233.64 37.2483 233.418C37.784 233.196 38.2419 232.82 38.5641 232.338C38.8863 231.856 39.0582 231.289 39.0582 230.709C39.0582 229.932 38.7493 229.186 38.1995 228.636C37.6496 228.086 36.9039 227.777 36.1263 227.777Z",
    fill: "url(#paint83_radial_928_2349)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M179.684 135.866L146.114 135.866L111.14 105.374L35.98 105.374L35.98 103.805L111.727 103.805L146.7 134.302L179.098 134.302L192.824 122.33L193.855 123.513L179.684 135.866Z",
    fill: "url(#paint84_radial_928_2349)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1263 101.645C35.5464 101.645 34.9795 101.817 34.4974 102.139C34.0152 102.461 33.6394 102.919 33.4175 103.455C33.1956 103.991 33.1375 104.58 33.2507 105.149C33.3638 105.718 33.643 106.24 34.0531 106.65C34.4631 107.06 34.9855 107.339 35.5543 107.453C36.123 107.566 36.7125 107.508 37.2483 107.286C37.784 107.064 38.2419 106.688 38.5641 106.206C38.8863 105.724 39.0582 105.157 39.0582 104.577C39.0582 103.799 38.7493 103.054 38.1995 102.504C37.6496 101.954 36.9039 101.645 36.1263 101.645Z",
    fill: "url(#paint85_radial_928_2349)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M535.378 159.253L388.136 159.253L388.136 160.817L535.378 160.817L535.378 159.253Z",
    fill: "url(#paint86_radial_928_2349)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M538.173 174.49L390.931 174.49L390.931 176.053L538.173 176.053L538.173 174.49Z",
    fill: "url(#paint87_radial_928_2349)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M391.078 172.33C390.498 172.33 389.931 172.502 389.449 172.824C388.967 173.146 388.591 173.604 388.369 174.14C388.147 174.675 388.089 175.265 388.202 175.834C388.315 176.403 388.595 176.925 389.005 177.335C389.415 177.745 389.937 178.024 390.506 178.137C391.075 178.251 391.664 178.192 392.2 177.971C392.736 177.749 393.194 177.373 393.516 176.891C393.838 176.409 394.01 175.842 394.01 175.262C394.01 174.484 393.701 173.738 393.151 173.189C392.601 172.639 391.856 172.33 391.078 172.33Z",
    fill: "url(#paint88_radial_928_2349)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M297.949 185.924L276.996 167.653L295.838 151.225L296.869 152.407L279.38 167.653L298.975 184.742L297.949 185.924Z",
    fill: "url(#paint89_radial_928_2349)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M298.179 154.132C298.613 153.75 298.925 153.247 299.075 152.688C299.224 152.129 299.205 151.538 299.019 150.99C298.834 150.442 298.49 149.961 298.031 149.607C297.573 149.254 297.02 149.045 296.442 149.005C295.865 148.966 295.288 149.098 294.786 149.386C294.284 149.674 293.878 150.103 293.619 150.621C293.361 151.139 293.261 151.722 293.333 152.296C293.406 152.871 293.646 153.411 294.025 153.849C294.278 154.141 294.587 154.381 294.933 154.554C295.28 154.727 295.657 154.829 296.043 154.856C296.429 154.882 296.817 154.832 297.183 154.707C297.55 154.583 297.888 154.388 298.179 154.132Z",
    fill: "url(#paint90_radial_928_2349)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M255.636 198.766L216.119 198.766L216.119 197.197L251.458 197.197L237.131 184.702L238.157 183.525L255.636 198.766Z",
    fill: "url(#paint91_radial_928_2349)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M239.686 181.99C239.248 181.611 238.708 181.371 238.134 181.299C237.56 181.226 236.977 181.326 236.459 181.584C235.941 181.843 235.511 182.249 235.223 182.751C234.936 183.253 234.803 183.83 234.843 184.407C234.882 184.985 235.092 185.538 235.445 185.996C235.798 186.455 236.279 186.799 236.827 186.985C237.375 187.17 237.966 187.19 238.526 187.04C239.085 186.89 239.587 186.578 239.97 186.144C240.225 185.853 240.421 185.515 240.545 185.148C240.669 184.782 240.719 184.394 240.693 184.008C240.667 183.622 240.564 183.245 240.391 182.898C240.218 182.552 239.979 182.243 239.686 181.99Z",
    fill: "url(#paint92_radial_928_2349)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M238.157 151.791L237.131 150.609L251.458 138.114L216.119 138.114L216.119 136.545L255.636 136.545L238.157 151.791Z",
    fill: "url(#paint93_radial_928_2349)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M235.821 148.884C235.386 149.266 235.073 149.768 234.923 150.328C234.773 150.887 234.792 151.478 234.977 152.027C235.163 152.576 235.506 153.057 235.965 153.411C236.424 153.764 236.977 153.974 237.555 154.013C238.133 154.053 238.709 153.92 239.212 153.632C239.714 153.345 240.12 152.914 240.379 152.396C240.637 151.878 240.736 151.294 240.663 150.72C240.591 150.145 240.349 149.605 239.97 149.168C239.717 148.876 239.408 148.636 239.062 148.464C238.717 148.292 238.34 148.189 237.955 148.163C237.569 148.137 237.182 148.187 236.816 148.311C236.45 148.434 236.112 148.629 235.821 148.884Z",
    fill: "url(#paint94_radial_928_2349)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M509.954 63.1101L413.557 63.1101L413.557 64.6738L509.954 64.6738L509.954 63.1101Z",
    fill: "url(#paint95_radial_928_2349)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M509.806 66.8385C510.386 66.8385 510.953 66.6665 511.435 66.3444C511.917 66.0222 512.293 65.5643 512.515 65.0286C512.737 64.4928 512.795 63.9033 512.682 63.3345C512.569 62.7658 512.29 62.2434 511.88 61.8333C511.47 61.4233 510.947 61.1441 510.378 61.0309C509.81 60.9178 509.22 60.9759 508.684 61.1978C508.149 61.4197 507.691 61.7955 507.369 62.2776C507.046 62.7598 506.875 63.3267 506.875 63.9066C506.875 64.6842 507.183 65.4299 507.733 65.9797C508.283 66.5296 509.029 66.8385 509.806 66.8385Z",
    fill: "url(#paint96_radial_928_2349)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M512.749 270.633L416.351 270.633L416.351 272.196L512.749 272.197L512.749 270.633Z",
    fill: "url(#paint97_radial_928_2349)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M416.498 274.357C418.123 274.357 419.44 273.04 419.44 271.415C419.44 269.79 418.123 268.473 416.498 268.473C414.873 268.473 413.556 269.79 413.556 271.415C413.556 273.04 414.873 274.357 416.498 274.357Z",
    fill: "url(#paint98_radial_928_2349)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M138.657 279.688L137.63 278.51L156.639 261.93L181.341 261.93L181.341 263.499L157.226 263.499L138.657 279.688Z",
    fill: "url(#paint99_radial_928_2349)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M136.32 276.785C135.886 277.167 135.574 277.67 135.424 278.229C135.275 278.788 135.294 279.379 135.48 279.927C135.665 280.476 136.009 280.957 136.468 281.31C136.927 281.663 137.48 281.872 138.057 281.912C138.635 281.951 139.211 281.819 139.713 281.531C140.216 281.244 140.622 280.814 140.88 280.296C141.139 279.778 141.238 279.195 141.166 278.621C141.093 278.046 140.853 277.506 140.474 277.068C140.221 276.776 139.912 276.536 139.566 276.363C139.219 276.19 138.842 276.088 138.456 276.061C138.07 276.035 137.683 276.086 137.316 276.21C136.949 276.334 136.611 276.529 136.32 276.785Z",
    fill: "url(#paint100_radial_928_2349)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M181.341 73.3813L156.639 73.3813L137.63 56.8012L138.657 55.6235L157.226 71.8128L181.341 71.8128L181.341 73.3813Z",
    fill: "url(#paint101_radial_928_2349)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M140.191 54.0891C139.753 53.7104 139.213 53.4697 138.638 53.3975C138.064 53.3252 137.481 53.4246 136.963 53.683C136.445 53.9415 136.015 54.3475 135.728 54.8499C135.44 55.3523 135.308 55.9285 135.347 56.506C135.387 57.0836 135.596 57.6365 135.949 58.0952C136.302 58.5538 136.783 58.8977 137.332 59.0834C137.88 59.2691 138.471 59.2884 139.03 59.1388C139.589 58.9892 140.092 58.6774 140.474 58.2427C140.73 57.9521 140.925 57.6137 141.049 57.2471C141.173 56.8805 141.224 56.493 141.197 56.1069C141.171 55.7207 141.069 55.3436 140.896 54.9973C140.723 54.651 140.483 54.3423 140.191 54.0891Z",
    fill: "url(#paint102_radial_928_2349)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M581.224 28.0975L533.042 28.0975L520.816 17.435L521.842 16.2524L533.629 26.5338L581.224 26.5338L581.224 28.0975Z",
    fill: "url(#paint103_radial_928_2349)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M404.462 319.059L392.676 308.778L345.081 308.778L345.081 307.214L393.267 307.214L405.493 317.876L404.462 319.059Z",
    fill: "url(#paint104_radial_928_2349)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M345.227 305.054C344.647 305.054 344.08 305.226 343.598 305.548C343.116 305.87 342.74 306.328 342.518 306.864C342.296 307.399 342.238 307.989 342.351 308.558C342.464 309.126 342.744 309.649 343.154 310.059C343.564 310.469 344.086 310.748 344.655 310.861C345.224 310.974 345.813 310.916 346.349 310.694C346.885 310.473 347.343 310.097 347.665 309.615C347.987 309.132 348.159 308.566 348.159 307.986C348.159 307.208 347.85 306.462 347.3 305.913C346.75 305.363 346.004 305.054 345.227 305.054Z",
    fill: "url(#paint105_radial_928_2349)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M521.842 319.059L520.816 317.876L533.042 307.214L581.224 307.214L581.224 308.778L533.629 308.778L521.842 319.059Z",
    fill: "url(#paint106_radial_928_2349)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M393.267 28.0977L345.081 28.0977L345.081 26.534L392.676 26.534L404.462 16.2527L405.493 17.4352L393.267 28.0977Z",
    fill: "url(#paint107_radial_928_2349)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M345.227 30.2572C346.852 30.2572 348.169 28.9402 348.169 27.3155C348.169 25.6908 346.852 24.3738 345.227 24.3738C343.602 24.3738 342.285 25.6908 342.285 27.3155C342.285 28.9402 343.602 30.2572 345.227 30.2572Z",
    fill: "url(#paint108_radial_928_2349)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.6189 332.033L-34.1963 332.033L-34.1963 330.469L-14.2102 330.469L4.59824 314.07L5.6293 315.252L-13.6189 332.033Z",
    fill: "url(#paint109_radial_928_2349)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59823 21.2414L-14.2102 4.84204L-34.1963 4.84204L-34.1963 3.27344L-13.6189 3.27344L5.62929 20.0588L4.59823 21.2414Z",
    fill: "url(#paint110_radial_928_2349)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_928_2349)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -38.3403,
    y: -38.9998,
    width: 610,
    height: 414,
    fill: "url(#paint111_radial_928_2349)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178.362,
    y: 80.7932,
    width: 174.141,
    height: 174.141,
    rx: 12,
    fill: "#26E587"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M197.328 114.845L209.807 103.041C212.035 100.934 214.986 99.759 218.053 99.759H320.675C327.302 99.759 332.675 105.132 332.675 111.759V223.968C332.675 230.595 327.302 235.968 320.675 235.968H209.328C202.701 235.968 197.328 230.595 197.328 223.968L197.328 125.622V114.845Z",
    fill: "#FEF336"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M238.736 170.56C238.736 171.388 238.681 172.133 238.57 172.795H221.812C221.949 174.45 222.529 175.747 223.549 176.685C224.57 177.623 225.825 178.092 227.315 178.092C229.467 178.092 230.998 177.167 231.908 175.319H238.157C237.495 177.526 236.226 179.347 234.35 180.781C232.474 182.188 230.17 182.892 227.439 182.892C225.232 182.892 223.246 182.409 221.48 181.443C219.743 180.45 218.377 179.057 217.384 177.264C216.418 175.471 215.936 173.402 215.936 171.057C215.936 168.684 216.418 166.602 217.384 164.809C218.349 163.015 219.701 161.636 221.439 160.671C223.177 159.705 225.177 159.222 227.439 159.222C229.619 159.222 231.563 159.691 233.274 160.629C235.012 161.567 236.35 162.905 237.288 164.643C238.253 166.353 238.736 168.326 238.736 170.56ZM232.736 168.905C232.708 167.415 232.17 166.229 231.122 165.346C230.074 164.436 228.791 163.981 227.274 163.981C225.839 163.981 224.625 164.422 223.632 165.305C222.667 166.16 222.074 167.36 221.853 168.905H232.736Z",
    fill: "#054940"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M252.937 182.809C250.923 182.809 249.102 182.464 247.475 181.774C245.875 181.085 244.606 180.092 243.668 178.795C242.73 177.498 242.247 175.967 242.22 174.202H248.427C248.509 175.388 248.923 176.326 249.668 177.016C250.44 177.705 251.489 178.05 252.813 178.05C254.165 178.05 255.227 177.733 255.999 177.098C256.772 176.436 257.158 175.581 257.158 174.533C257.158 173.678 256.896 172.974 256.372 172.422C255.847 171.871 255.185 171.443 254.385 171.14C253.613 170.809 252.537 170.45 251.158 170.064C249.282 169.512 247.751 168.974 246.564 168.45C245.406 167.898 244.399 167.084 243.544 166.009C242.716 164.905 242.302 163.443 242.302 161.622C242.302 159.912 242.73 158.422 243.585 157.153C244.44 155.884 245.64 154.919 247.185 154.257C248.73 153.567 250.496 153.222 252.482 153.222C255.461 153.222 257.875 153.953 259.723 155.415C261.599 156.85 262.634 158.864 262.827 161.457H256.454C256.399 160.464 255.972 159.65 255.172 159.015C254.399 158.353 253.365 158.022 252.068 158.022C250.937 158.022 250.027 158.312 249.337 158.891C248.675 159.471 248.344 160.312 248.344 161.415C248.344 162.188 248.592 162.836 249.089 163.36C249.613 163.857 250.247 164.271 250.992 164.602C251.765 164.905 252.84 165.264 254.22 165.678C256.096 166.229 257.627 166.781 258.813 167.333C259.999 167.884 261.02 168.712 261.875 169.816C262.73 170.919 263.158 172.367 263.158 174.16C263.158 175.705 262.758 177.14 261.958 178.464C261.158 179.788 259.985 180.85 258.441 181.65C256.896 182.423 255.061 182.809 252.937 182.809Z",
    fill: "#054940"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M273.974 153.636V182.519H268.18V153.636H273.974Z",
    fill: "#054940"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M311.187 153.636V182.519H305.394V163.733L297.656 182.519H293.27L285.49 163.733V182.519H279.697V153.636H286.277L295.463 175.112L304.649 153.636H311.187Z",
    fill: "#054940"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M193.239 97.7832C193.146 97.1309 193.698 96.5686 194.352 96.6498L206.785 98.194C207.607 98.2961 207.955 99.2961 207.375 99.8871L196.709 110.746C196.128 111.337 195.122 111.006 195.005 110.186L193.239 97.7832Z",
    fill: "#054940"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M192.156 70.4483C192.156 68.5439 193.7 67 195.604 67C197.509 67 199.052 68.5439 199.052 70.4483V80.7933H192.156V70.4483Z",
    fill: "#FEF336"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M211.984 70.4483C211.984 68.5439 213.528 67 215.432 67C217.337 67 218.881 68.5439 218.881 70.4483V80.7933H211.984V70.4483Z",
    fill: "#FEF336"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M231.812 70.4483C231.812 68.5439 233.355 67 235.26 67C237.164 67 238.708 68.5439 238.708 70.4483V80.7933H231.812V70.4483Z",
    fill: "#FEF336"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M251.64 70.4483C251.64 68.5439 253.184 67 255.088 67C256.992 67 258.536 68.5439 258.536 70.4483V80.7933H251.64V70.4483Z",
    fill: "#FEF336"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M271.467 70.4483C271.467 68.5439 273.011 67 274.916 67C276.82 67 278.364 68.5439 278.364 70.4483V80.7933H271.467V70.4483Z",
    fill: "#FEF336"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M291.295 70.4483C291.295 68.5439 292.839 67 294.744 67C296.648 67 298.192 68.5439 298.192 70.4483V80.7933H291.295V70.4483Z",
    fill: "#FEF336"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M311.123 70.4483C311.123 68.5439 312.667 67 314.571 67C316.476 67 318.02 68.5439 318.02 70.4483V80.7933H311.123V70.4483Z",
    fill: "#FEF336"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M330.951 70.4483C330.951 68.5439 332.495 67 334.4 67C336.304 67 337.848 68.5439 337.848 70.4483V80.7933H330.951V70.4483Z",
    fill: "#FEF336"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M337.848 265.279C337.848 267.183 336.304 268.727 334.399 268.727C332.495 268.727 330.951 267.183 330.951 265.279L330.951 254.934L337.848 254.934L337.848 265.279Z",
    fill: "#FEF336"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M318.02 265.279C318.02 267.183 316.476 268.727 314.571 268.727C312.667 268.727 311.123 267.183 311.123 265.279L311.123 254.934L318.02 254.934L318.02 265.279Z",
    fill: "#FEF336"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M298.192 265.279C298.192 267.183 296.648 268.727 294.744 268.727C292.839 268.727 291.295 267.183 291.295 265.279L291.295 254.934L298.192 254.934L298.192 265.279Z",
    fill: "#FEF336"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M278.364 265.279C278.364 267.183 276.82 268.727 274.915 268.727C273.011 268.727 271.467 267.183 271.467 265.279L271.467 254.934L278.364 254.934L278.364 265.279Z",
    fill: "#FEF336"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M258.536 265.279C258.536 267.183 256.992 268.727 255.088 268.727C253.183 268.727 251.639 267.183 251.639 265.279L251.639 254.934L258.536 254.934L258.536 265.279Z",
    fill: "#FEF336"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M238.708 265.279C238.708 267.183 237.164 268.727 235.26 268.727C233.355 268.727 231.811 267.183 231.811 265.279L231.811 254.934L238.708 254.934L238.708 265.279Z",
    fill: "#FEF336"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M218.88 265.279C218.88 267.183 217.337 268.727 215.432 268.727C213.528 268.727 211.984 267.183 211.984 265.279L211.984 254.934L218.88 254.934L218.88 265.279Z",
    fill: "#FEF336"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M199.052 265.279C199.052 267.183 197.508 268.727 195.604 268.727C193.699 268.727 192.156 267.183 192.156 265.279L192.156 254.934L199.052 254.934L199.052 265.279Z",
    fill: "#FEF336"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 240.279C166.544 240.279 165 238.735 165 236.83C165 234.926 166.544 233.382 168.448 233.382L178.793 233.382L178.793 240.279L168.448 240.279Z",
    fill: "#FEF336"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 220.45C166.544 220.45 165 218.907 165 217.002C165 215.098 166.544 213.554 168.448 213.554L178.793 213.554L178.793 220.45L168.448 220.45Z",
    fill: "#FEF336"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 200.623C166.544 200.623 165 199.079 165 197.174C165 195.27 166.544 193.726 168.448 193.726L178.793 193.726L178.793 200.623L168.448 200.623Z",
    fill: "#FEF336"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 180.795C166.544 180.795 165 179.251 165 177.346C165 175.442 166.544 173.898 168.448 173.898L178.793 173.898L178.793 180.795L168.448 180.795Z",
    fill: "#FEF336"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 160.967C166.544 160.967 165 159.423 165 157.518C165 155.614 166.544 154.07 168.448 154.07L178.793 154.07L178.793 160.967L168.448 160.967Z",
    fill: "#FEF336"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 141.139C166.544 141.139 165 139.595 165 137.691C165 135.786 166.544 134.242 168.448 134.242L178.793 134.242L178.793 141.139L168.448 141.139Z",
    fill: "#FEF336"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 121.311C166.544 121.311 165 119.767 165 117.863C165 115.958 166.544 114.414 168.448 114.414L178.793 114.414L178.793 121.311L168.448 121.311Z",
    fill: "#FEF336"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M168.448 101.483C166.544 101.483 165 99.9393 165 98.0348C165 96.1304 166.544 94.5865 168.448 94.5865L178.793 94.5865L178.793 101.483L168.448 101.483Z",
    fill: "#FEF336"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 240.279C364.753 240.279 366.296 238.735 366.296 236.83C366.296 234.926 364.753 233.382 362.848 233.382L352.503 233.382L352.503 240.279L362.848 240.279Z",
    fill: "#FEF336"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 220.45C364.753 220.45 366.296 218.907 366.296 217.002C366.296 215.098 364.753 213.554 362.848 213.554L352.503 213.554L352.503 220.45L362.848 220.45Z",
    fill: "#FEF336"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 200.623C364.753 200.623 366.296 199.079 366.296 197.174C366.296 195.27 364.753 193.726 362.848 193.726L352.503 193.726L352.503 200.623L362.848 200.623Z",
    fill: "#FEF336"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 180.795C364.753 180.795 366.296 179.251 366.296 177.346C366.296 175.442 364.753 173.898 362.848 173.898L352.503 173.898L352.503 180.795L362.848 180.795Z",
    fill: "#FEF336"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 160.967C364.753 160.967 366.296 159.423 366.296 157.518C366.296 155.614 364.753 154.07 362.848 154.07L352.503 154.07L352.503 160.967L362.848 160.967Z",
    fill: "#FEF336"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 141.139C364.753 141.139 366.296 139.595 366.296 137.691C366.296 135.786 364.753 134.242 362.848 134.242L352.503 134.242L352.503 141.139L362.848 141.139Z",
    fill: "#FEF336"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 121.311C364.753 121.311 366.296 119.767 366.296 117.863C366.296 115.958 364.753 114.414 362.848 114.414L352.503 114.414L352.503 121.311L362.848 121.311Z",
    fill: "#FEF336"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M362.848 101.483C364.753 101.483 366.296 99.9393 366.296 98.0348C366.296 96.1304 364.753 94.5865 362.848 94.5865L352.503 94.5865L352.503 101.483L362.848 101.483Z",
    fill: "#FEF336"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.47 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.325) scale(611.349 611.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.315) scale(611.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.354 611.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.359 611.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.365 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.459 164.321) scale(611.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.459 164.321) scale(611.355 611.353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.377 611.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.359 611.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.35 611.353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.372 611.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.35 611.353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.463 164.32) scale(611.363 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.365 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.462 164.32) scale(611.362 611.368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.326) scale(611.349 611.346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.326) scale(611.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.552 164.321) scale(611.203 611.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.47 164.325) scale(611.387 611.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.465 164.326) scale(611.356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.355 611.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.377 611.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.359 611.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.375 611.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.552 164.321) scale(611.091 611.091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.474 164.32) scale(611.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.552 164.321) scale(611.11 611.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.353 611.356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.36 611.361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.359 611.357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.459 164.324) scale(611.349 611.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.459 164.326) scale(611.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.327) scale(611.364 611.355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.325) scale(611.349 611.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.321) scale(611.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.463 164.32) scale(611.363 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.365 611.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.473 164.325) scale(611.374 611.377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.473 164.32) scale(611.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.325) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.325) scale(611.344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.454 164.32) scale(611.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.364 611.367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.552 164.321) scale(610.68 610.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.465 164.321) scale(611.352 611.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.369 611.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.463 164.32) scale(611.352 611.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.353 611.355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.465 164.316) scale(611.34 611.342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.326) scale(611.375 611.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.552 164.322) scale(611.179 611.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.35 611.356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.468 164.32) scale(611.369 611.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.37 611.369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.32) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.315) scale(611.371 611.377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.469 164.321) scale(611.359 611.359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.465 164.32) scale(611.356 611.353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.321) scale(611.364 611.364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.464 164.32) scale(611.364 611.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#30B3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2896CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#12445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#0A2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#051118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_928_2349",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.66 168) rotate(90) scale(207 305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEsim);
export default __webpack_public_path__ + "static/media/login-esim.b358d1b4ae31a43011eb6dbc3138f3b0.svg";
export { ForwardRef as ReactComponent };